import type {z} from "zod/v4-mini"
import type {FundamentalLikeNode} from "#template/role-markers"
import {createFundamentalMarker} from "#template/role-markers"
import {isTransformValue, transformValue, type TransformValue} from "#template/value-types"

export const transformLikeMarker = Symbol("TransformLike")

export interface TransformLikeNode extends FundamentalLikeNode<TransformValue | null> {
    readonly [transformLikeMarker]: true
}

export const transformMarker = createFundamentalMarker<TransformLikeNode, TransformValue>(transformLikeMarker, {
    rawSchema: transformValue,
    acceptsRaw: isTransformValue,
})
export const {
    isLikeNode: isTransformLikeNode,
    isLikeNodeClass: isTransformLikeNodeClass,
    likeNode: transformLikeNode,
    isLike: isTransformLike,
    like: transformLike,
} = transformMarker
export type TransformLike = z.infer<typeof transformLike>
